import { EstimateDto } from "./types";

export type DateField = "estimateDate" | "createdTimestamp";

export type EstimateSearchCriteria = {
  // Basic
  companyInCharge?: string;
  contentType?: string;
  companyName?: string;
  recipientName?: string;
  dateField?: DateField;
  dateFrom?: string; // YYYY-MM-DD
  dateTo?: string;   // YYYY-MM-DD

  // Detailed
  contentTitle?: string;
  siteName?: string;
  sender?: string;
  deliveryLocation?: string;
  personInCharge?: string;
  itemName?: string;
  itemSize?: string;
};

export type EstimateSortField =
  | "createdTimestamp"
  | "estimateDate"
  | "companyName"
  | "companyInCharge";

export type EstimateSearchPagination = {
  page: number; // 1-based
  pageSize: number;
  sortField?: EstimateSortField;
  sortOrder?: "asc" | "desc";
};

export type EstimateSearchResponse = {
  data: EstimateDto[];
  total: number;
  page: number;
  pageSize: number;
};

export const defaultCriteria: EstimateSearchCriteria = {
  dateField: "estimateDate",
};

export const defaultPagination: EstimateSearchPagination = {
  page: 1,
  pageSize: 20,
  sortField: "createdTimestamp",
  sortOrder: "desc",
};
